import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Provider } from '../hooks/useXForm';
const XForm = ({ children, formMachine, onInvalid, onSubmit, onSubmitError, submit: handleSubmit }) => {
    const [formMachineSubscription, setFormMachineSubscription] = useState();
    const [actors, setActors] = useState(formMachine.getSnapshot().context.actors);
    const [isValidating, setIsValidating] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submit = () => {
        formMachine.send({
            type: 'SUBMIT'
        });
    };
    useEffect(() => {
        if (!formMachine.getSnapshot().done) {
            formMachine.send({
                type: 'SET_HANDLERS',
                onInvalid: (fieldErrors) => {
                    if (onInvalid) {
                        onInvalid(fieldErrors);
                    }
                    const firstError = Object.keys(fieldErrors).filter((e) => fieldErrors[e])[0];
                    const firstInvalidInput = document.querySelector(`[data-scroll="${firstError}"]`);
                    firstInvalidInput.scrollIntoView();
                },
                onSubmit,
                onSubmitError,
                submit: handleSubmit
            });
        }
    }, [formMachine, handleSubmit, onInvalid, onSubmit, onSubmitError]);
    useEffect(() => {
        const subscription = formMachine.subscribe((state) => {
            if (state.matches('lifecycle.editing')) {
                setIsValidating(false);
                setIsSubmitting(false);
            }
            if (state.matches('lifecycle.validating')) {
                setIsValidating(true);
            }
            if (state.matches('lifecycle.submitting')) {
                setIsSubmitting(true);
            }
        });
        if (formMachineSubscription) {
            formMachineSubscription.unsubscribe();
        }
        setFormMachineSubscription(subscription);
        setActors(formMachine.getSnapshot().context.actors);
        return subscription.unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMachine]);
    return (_jsx(Provider, Object.assign({ value: {
            actors,
            formMachine,
            isSubmitting,
            isValidating,
            submit
        } }, { children: children })));
};
export default XForm;
